<!-- composer -->
<div class="composer">
  @if (showRecipients()) {
    <div class="recipients">
      <span class="recipients-label" id="fb-recipients-label">
        Notify
      </span>

      <div class="recipients-field" (focusout)="onRecipientsFocusOut($event)">
        <button
          type="button"
          class="recipients-trigger"
          [class.is-empty]="!selectedRecipients().length"
          [disabled]="posting()"
          (click)="toggleRecipients()"
          [attr.aria-expanded]="recipientsOpen()"
          aria-haspopup="listbox"
          aria-labelledby="fb-recipients-label"
        >
          <span class="recipients-summary">{{ recipientSummary() }}</span>
          <svg
            class="recipients-caret"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>

        @if (recipientsOpen()) {
          <div class="recipients-menu" role="listbox" aria-multiselectable="true">
            @for (option of recipientOptions(); track option.email) {
              <button
                type="button"
                class="recipients-option"
                [class.is-selected]="isSelected(option.email)"
                [class.is-author]="isFeedbackAuthor(option.email)"
                role="option"
                [attr.aria-selected]="isSelected(option.email)"
                (click)="toggleRecipient(option.email)"
              >
                <span class="recipients-check" aria-hidden="true">
                  @if (isSelected(option.email)) {
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                  }
                </span>

                <span class="recipients-text">
                  <span class="recipients-name">{{ option.label || option.email }}</span>
                  @if (option.label && option.label !== option.email) {
                    <span class="recipients-email">{{ option.email }}</span>
                  }
                </span>

                @if (isFeedbackAuthor(option.email)) {
                  <span class="recipients-author-badge">Feedback author</span>
                }
              </button>
            }
          </div>
        }
      </div>
    </div>
  }

  <textarea
    class="composer-input"
    rows="3"
    placeholder="Add a comment…"
    [value]="draft()"
    [disabled]="posting()"
    (input)="draft.set($any($event.target).value)"
    (keydown.control.enter)="send()"
    (keydown.meta.enter)="send()"
    aria-label="Add a comment"
  ></textarea>

  <div class="composer-actions">
    @if (canPostPrivate()) {
      <button
        type="button"
        class="privacy-toggle"
        [class.is-private]="effectivePrivate()"
        (click)="togglePrivate()"
        [disabled]="notifiesExternal()"
        [attr.aria-pressed]="effectivePrivate()"
        [title]="
          notifiesExternal()
            ? 'Public — you are notifying someone outside Brafton'
            : effectivePrivate()
              ? 'Internal only — the client will not see this'
              : 'Visible to the client'
        "
      >
        <span class="privacy-switch"><span class="privacy-knob"></span></span>
        <svg
          class="privacy-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        <span class="privacy-label">{{ effectivePrivate() ? 'Private' : 'Public' }}</span>
      </button>
    }

    <span class="composer-spacer"></span>

    <button type="button" class="send" [disabled]="!canSend()" (click)="send()">
      {{ posting() ? 'Sending…' : 'Send' }}
    </button>
  </div>
</div>

<!-- thread -->
@if (loading()) {
  <p class="thread-state">Loading comments…</p>
} @else if (!ordered().length) {
  <p class="thread-state">No comments yet.</p>
} @else {
  <div class="thread">
    @for (entry of ordered(); track entry.id) {
      <div class="row" [class.is-mine]="isMine(entry)">
        <span class="avatar" [class.is-mine]="isMine(entry)">{{ initial(entry.author) }}</span>

        <div class="bubble-wrap">
          <div class="meta">
            <span class="meta-name">{{ entry.author || 'Unknown' }}</span>
            @if (entry.role) {
              <span class="meta-role">· {{ entry.role }}</span>
            }
            @if (entry.created) {
              <span class="meta-time">{{ relativeTime(entry.created) }}</span>
            }
            @if (entry.isPrivate) {
              <span class="private-badge">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                Private
              </span>
            }
          </div>

          <div
            class="bubble"
            [class.is-mine]="isMine(entry)"
            [class.is-private]="entry.isPrivate"
          >
            {{ entry.text }}
          </div>
        </div>
      </div>
    }
  </div>
}
